<template>
  <div
    class="delivery-info text-xs"
    :class="deliveryInfoClass"
  >
    <span class="text-xs mwst">inkl. MwSt.</span>
    <template v-if="!onlyAvailableInStore && showShipmentInformation && shipmentBruttoPrice != undefined">
      <template v-if="shipmentBruttoPrice === 0"
        >&nbsp;<span
          class="text-success"
          :class="shippingLinkStyle"
          @click.prevent="openModal"
          >versandkostenfrei</span
        ></template
      >
      <template v-else-if="pprice?.shipmentArray?.[0]?.shipmentType === 'ESD'"
        >&nbsp;<span
          class="text-success"
          :class="shippingLinkStyle"
          >Kostenlose Zusendung des Codes erfolgt innerhalb von 30 Minuten</span
        ></template
      >
      <span v-else
        >, zzgl.
        <br v-if="lineBreakDeliveryInfo" />
        <span
          class="text-primary"
          :class="shippingLinkStyle"
          @click.prevent="openModal"
          >Versand</span
        >&nbsp;{{ shipmentString }}</span
      >
      <ArticleDeliveryTiming
        v-if="showShippingEstimate"
        :price="localprice"
      />
      <Teleport to="#modals">
        <BasicModal
          v-if="enableDeliveryModal && showModal"
          class="lg"
          @close-modal="showModal = false"
        >
          <template #icon>
            <BasicIcon
              :name="'xmark-solid'"
              class="w-4 close-img"
            />
          </template>
          <div class="p-4">
            <ContentStaticDeliveryInformation />
          </div>
        </BasicModal>
      </Teleport>
    </template>
  </div>
</template>
<script setup lang="ts">
import { type FullPrice, NeoStoreAvailability } from '@expert/types';

interface Props {
  pprice: FullPrice;
  localprice: FullPrice;
  shipmentBruttoPrice: number;
  enableDeliveryModal?: boolean;
  showShipmentInformation?: boolean;
  hideShipmentPrice?: boolean;
  deliveryInfoClass?: string;
  addsReserveSpace?: boolean;
  lineBreakDeliveryInfo?: boolean;
  showShippingEstimate?: boolean;
  severalShipmentOptions?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  enableDeliveryModal: true,
  showShipmentInformation: true,
  hideShipmentPrice: false,
  deliveryInfoClass: '',
  addsReserveSpace: false,
  lineBreakDeliveryInfo: false,
  showShippingEstimate: false,
  severalShipmentOptions: false
});

const showModal = ref(false);

const onlyAvailableInStore = computed(() => {
  const noOnlineAvailability =
    props.pprice?.onlineAvailability === NeoStoreAvailability.NONE || !props.pprice?.onlineAvailability;
  const storeAvailableOrPreorder =
    props.pprice?.storeAvailability === NeoStoreAvailability.AVAILABLE
    || props.pprice?.storeAvailability === NeoStoreAvailability.PREORDER;

  return noOnlineAvailability && storeAvailableOrPreorder;
});

const shipmentString = computed(() => {
  const price: number = props.shipmentBruttoPrice ?? 0;
  if (price > 0 && !props.hideShipmentPrice) {
    return (props.severalShipmentOptions ? 'ab ':'für ') + (typeof price !== 'number' ? price:price.toFixed(2)) + ' €';
  }

  return '';
});

const shippingLinkStyle = computed(() => {
  return ['underline', { 'cursor-pointer': props.enableDeliveryModal }];
});

const openModal = () => {
  if (props.enableDeliveryModal) {
    showModal.value = true;
  }
};
</script>
